module.exports = __webpack_public_path__ + "img/20.22dc552a.jpg";